// import { createContext, useContext, useState, useEffect, useCallback, useMemo, useRef } from 'react';
// import Cookies from 'js-cookie';
// import { jwtDecode } from 'jwt-decode';
// import LoadingComponent from '../components/Loading/LoadingComponent';
// import { useNavigate } from "react-router-dom";
// import {
//     fetchYears, fetchLevels, fetchEmployees, fetchUserLevels, fetchTrainingPlans, fetchFarmers, fetchTrinigTypes,
//     fetchTrainingStatus, fetchCropTypes, fetchSoilTypes, fetchTrainingSessions, fetchModulePages,
//     fetchFieldBook, fetchSoilReports, fetchVillageGroups, fetchTrainingReport, fetchSoilReportSummary, fetchFieldBookSummary, fetchAttendance,
//     fetchAdOption, fetchAdOptionSummary, fetchVillageGroupsAdOptionSummary, fetchIndividualFarmersDetails,
//     fetchTrainingPlanLevelWiseReport,
// } from './apiUtils';
// import { APP_ROUTES } from '../config/appRoutes';

// const DataContext = createContext();

// export const DataProvider = ({ children }) => {
//     const savedClientId = Number(localStorage.getItem("user_client_id")) || 1;
//     const savedLevelId = Number(localStorage.getItem("level_id")) || 1;

//     const [data, setData] = useState({
//         user: {},
//         years: [],
//         trainingTypes: [],
//         levels: [], userLevels: [], trainingPlans: [], farmers: [],
//         trainingStatus: [], soilTypes: [], cropTypes: [], trainingSessions: [],
//         modulePages: [], villageGroups: [], fieldBooks: [], soilReports: [],
//         trainingReport: [], subLoading: true, soilReportSummary: [], fieldBookSummary: [], sessionAttendance: [],
//         adOptionData: [], adOptionSummaryReport: [], villageGroupAdoptionSummaryReport: [], individualFarmersDetails: [],
//         user_client_id: savedClientId,
//         trainingPlanLevelReports: [],
//         user_level_id: savedLevelId
//     });

//     const [employees, setEmployees] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [isAuthenticated, setIsAuthenticated] = useState(false);
//     const hasLoadedRef = useRef(false);

//     const navigate = useNavigate();

//     // Generic fetch helper for API calls with error handling
//     const fetchData = useCallback(async (fetchFunction, params = {}) => {
//         try {
//             await fetchFunction(setData, setError, params);
//         } catch (err) {
//             setError(err.response?.data?.message || err.message || 'Error fetching data');
//             console.error(err);
//         }
//     }, []);

//     // Main data fetching after user authentication
//     const fetchDataAfterLogin = useCallback(async () => {
//         setLoading(true);
//         localStorage.removeItem('client_id');
//         try {
//             await Promise.all([
//                 fetchData(fetchYears),
//                 fetchData(fetchTrinigTypes),
// fetchData(fetchLevels, {
//     level_id: data?.user.level_id,
//     client_id: data?.user_client_id
// }),
//                 fetchData(fetchUserLevels),
//                 fetchData(fetchTrainingStatus),
//                 fetchData(fetchSoilTypes),
//                 fetchData(fetchModulePages),
//                 fetchData(fetchCropTypes),
//                 fetchData(fetchTrainingPlans, { level_id: data.user.level_id, client_id: data.user_client_id }),
//             ]);

//             const employeesData = await fetchEmployees(setEmployees, setError, { client_user_id: data.user.user_id, client_id: Number(localStorage.getItem("user_client_id")) || 1 });
//             setEmployees(employeesData || []);

//         } catch (err) {
//             setError(err.response?.data?.message || err.message || 'Error fetching data');
//         } finally {
//             setLoading(false);
//         }
//     }, [fetchData, data.user.level_id, data.user.user_id]);

//     useEffect(() => {
//         const checkTokenAndNavigate = () => {
//             const token = Cookies.get('farmerToken');
//             if (!token) {
//                 setLoading(false);
//                 navigate("/");
//                 return true;
//             }

//             const decoded = jwtDecode(token);
//             const user = decoded?.token?.[0];

//             if (!user) {
//                 setLoading(false);
//                 navigate("/");
//                 return;
//             }

//             const storedClientId = localStorage.getItem("user_client_id");
//             const clientId = storedClientId
//                 ? Number(storedClientId)
//                 : Number(user.client_id);

//             setData(prev => ({ ...prev, user, user_client_id: clientId }));


//             if (!storedClientId) {
//                 localStorage.setItem("user_client_id", clientId);
//             }

//             console.log("Active clientId:", clientId);

//             setIsAuthenticated(true);
//         };

//         checkTokenAndNavigate();
//     }, [navigate]);

//     useEffect(() => {
//         if (isAuthenticated) {
//             fetchDataAfterLogin();
//         }
//     }, [isAuthenticated, fetchDataAfterLogin]);


//     const loadClientBaseChange = async (clientId) => {
//         if (!isAuthenticated || !clientId) return;
//         setData(prev => ({
//             ...prev,
//             subLoading: true
//         }));
//         try {

//             await fetchData(fetchTrainingPlans, {
//                 level_id: data.user.level_id,
//                 client_id: clientId
//             });

//             await fetchData(fetchTrainingSessions, {
//                 client_id: clientId,
//                 employees
//             });

// await fetchData(fetchTrainingPlanLevelWiseReport, {
//     level_id: data.user.level_id ? data.user.level_id : 1,
//     client_id: Number(localStorage.getItem("user_client_id")) || 1,
//     employees
// });

//         } catch (error) {
//             console.error("Client load error:", error);
//         } finally {
//             setData(prev => ({
//                 ...prev,
//                 subLoading: false
//             }));
//         }
//     };

//     // ✅ SAFE DEFAULT TRIGGER
//     if (
//         isAuthenticated &&
//         savedClientId &&
//         !hasLoadedRef.current
//     ) {
//         hasLoadedRef.current = true;

//         setData(prev => ({
//             ...prev,
//             user_client_id: savedClientId
//         }));

//         // queue after render
//         setTimeout(() => {
//             loadClientBaseChange(savedClientId);
//         }, 0);
//     }

//     // const handleClientIdChange = (id) => {
//     //     if (!id) return;

//     //     setData(prev => ({
//     //         ...prev,
//     //         user_client_id: id,
//     //     }));
//     //     localStorage.setItem("user_client_id", id);
//     //     loadClientBaseChange(id);
//     //     handleEmployees(id);
//     //     window.location.reload();
//     // };


//     const handleClientIdChange = async (id) => {
//         if (!id) return;

//         setData(prev => ({
//             ...prev,
//             user_client_id: id,
//         }));

//         localStorage.setItem("user_client_id", id);
//         handleEmployees(id);
//         window.location.reload();
//     };

// const handleLogout = () => {
//     Cookies.remove('farmerToken');
//     localStorage.removeItem('user_client_id');
//     localStorage.removeItem('client_id');
//     navigate(APP_ROUTES.LOGIN);
//     setData(prev => ({ ...prev, user_client_id: "" }));
// };


//     useEffect(() => {

//         const fetchEmployeeData = async () => {
//             console.log("fetchdatatatat");

//             if (employees.length > 0) {
//                 setData(prev => ({
//                     ...prev,
//                     subLoading: true
//                 }));
//                 try {
//                     await Promise.all([
//                         fetchData(fetchFarmers, { employees }),
//                         fetchData(fetchTrainingSessions, { employees, client_id: data.user_client_id }),
//                         fetchData(fetchSoilReports, { employees }),
//                         fetchData(fetchFieldBook, { employees }),
//                         fetchData(fetchVillageGroups, { employees }),
//                         fetchData(fetchAdOption, { employees }),
//                         fetchData(fetchSoilReportSummary, { employees, year_id: 2 }),
// fetchData(fetchTrainingPlanLevelWiseReport, {
//     client_id: Number(localStorage.getItem("user_client_id")) || 1,
//     level_id: data.user.level_id ? data.user.level_id : 1,
//     employees,
// }),
//                     ]);
//                 } finally {
//                     setData(prev => ({
//                         ...prev,
//                         subLoading: false
//                     }));
//                 }
//             }
//         };
//         fetchEmployeeData();
//     }, [employees, fetchData, data.user_client_id, data.user]);



//     const handleTrainingPlans = useCallback(() => fetchData(fetchTrainingPlans, { level_id: data.user.level_id, client_id: data.user_client_id }), [data.user.level_id, data.user_client_id, fetchData]);

//     // Callback for fetching training sessions
//     const handleTrainingSessions = useCallback(() => fetchData(fetchTrainingSessions, { employees, client_id: data.user_client_id }), [employees, data.user_client_id, fetchData]);

//     const handleTrainingPlanReport = useCallback(async (level_id) => {
//         if (level_id) {
//             await fetchData(fetchTrainingPlanLevelWiseReport, {
//                 level_id,
//                 client_id: Number(localStorage.getItem("user_client_id")) || 1,
//                 employees
//             });
//         }
//     }, [data.user_client_id, employees]);

//     // Callback for fetching employees
//     const handleEmployees = useCallback(() => fetchData(fetchEmployees, { client_user_id: data.user.user_id, client_id: Number(localStorage.getItem("user_client_id")) || 1 }), [data.user.user_id, fetchData]);
//     // const handleEmployees = useCallback(
//     //     (clientId) => {
//     //         fetchData(fetchEmployees, {
//     //             client_user_id: data.user.user_id,
//     //             client_id: clientId,
//     //         });
//     //     },
//     //     [data.user.user_id, fetchData]
//     // );
//     // Callback for fetching field books
//     const handleFieldBooks = useCallback(() => fetchData(fetchFieldBook, { employees }), [employees, fetchData]);

//     // Callback for fetching soil reports
//     const handleSoilReports = useCallback(() => fetchData(fetchSoilReports, { employees }), [employees, fetchData]);

//     const handleAdOption = useCallback(() => fetchData(fetchAdOption, { employees }), [employees, fetchData]);

//     const handleTrainingReport = useCallback((trainingId) => {
//         if (trainingId) {
//             fetchData(fetchTrainingReport, { employees, training_plan_id: trainingId });
//         }
//     }, [employees, fetchData]);


//     const handleSoilReportSummary = useCallback((year_id) => {

//         if (year_id) {
//             fetchData(fetchSoilReportSummary, { employees, year_id: year_id });
//         }
//     }, [employees, fetchData]);

//     const handleFieldBookSummary = useCallback((year_id) => {

//         if (year_id) {
//             fetchData(fetchFieldBookSummary, { employees, year_id: year_id });
//         }
//     }, [employees, fetchData]);

//     const handleAdOptionSummary = useCallback((year_id) => {
//         if (year_id) {
//             fetchData(fetchAdOptionSummary, { employees, year_id: year_id });
//         }
//     }, [employees, fetchData])

//     const handleAttendance = useCallback((training_session_id) => {
//         if (training_session_id) {
//             fetchData(fetchAttendance, { training_session_id: training_session_id });
//         }
//     }, [employees, fetchData]);

//     const handleIndividualFarmersDetails = useCallback((training_session_id) => {

//         if (training_session_id) {
//             fetchData(fetchIndividualFarmersDetails, { training_session_id: training_session_id });
//         }
//     }, [employees, fetchData]);


//     const handleVillageGroupAdoptionSummary = useCallback((year_id) => {
//         if (year_id) {
//             fetchData(fetchVillageGroupsAdOptionSummary, { employees, year_id: year_id });
//         }
//     }, [employees, fetchData])

//     const contextValue = useMemo(() => ({
//         ...data,
//         employees,
//         loading,
//         error,
//         fetchDataAfterLogin,
//         handleTrainingPlans,
//         handleEmployees,
//         handleTrainingPlanReport,
//         handleFieldBooks,
//         handleTrainingSessions,
//         handleSoilReports,
//         handleTrainingReport,
//         handleSoilReportSummary,
//         handleFieldBookSummary,
//         handleAttendance,
//         handleAdOption,
//         handleAdOptionSummary,
//         handleVillageGroupAdoptionSummary,
//         handleIndividualFarmersDetails,
//         handleClientIdChange,
//         handleLogout,
//     }), [data, employees, loading, error, fetchDataAfterLogin, handleTrainingPlans, handleTrainingPlanReport, handleEmployees, handleFieldBooks, handleTrainingSessions, handleSoilReports, handleTrainingReport, handleSoilReportSummary, handleFieldBookSummary, handleAttendance, handleAdOption, handleAdOptionSummary, handleVillageGroupAdoptionSummary, handleIndividualFarmersDetails]);

//     return (
//         <DataContext.Provider value={contextValue}>
//             {loading ? <LoadingComponent /> : children}
//         </DataContext.Provider>
//     );
// };

// // Custom hook to access the data context
// export const useData = () => useContext(DataContext);



import { createContext, useContext, useState, useEffect, useCallback, useMemo, useRef } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import LoadingComponent from '../components/Loading/LoadingComponent';
import { useNavigate } from "react-router-dom";
import {
    fetchYears, fetchLevels, fetchEmployees, fetchUserLevels, fetchTrainingPlans, fetchFarmers, fetchTrinigTypes,
    fetchTrainingStatus, fetchCropTypes, fetchSoilTypes, fetchTrainingSessions, fetchModulePages,
    fetchFieldBook, fetchSoilReports, fetchVillageGroups, fetchTrainingReport, fetchSoilReportSummary,
    fetchFieldBookSummary, fetchAttendance, fetchAdOption, fetchAdOptionSummary,
    fetchVillageGroupsAdOptionSummary, fetchIndividualFarmersDetails,
    fetchTrainingPlanLevelWiseReport,
} from './apiUtils';
import { APP_ROUTES } from '../config/appRoutes';

const DataContext = createContext();

export const DataProvider = ({ children }) => {

    const savedClientId = Number(localStorage.getItem("user_client_id")) || 1;

    const [data, setData] = useState({
        user: {},
        years: [],
        trainingTypes: [],
        levels: [],
        userLevels: [],
        trainingPlans: [],
        farmers: [],
        trainingStatus: [],
        soilTypes: [],
        cropTypes: [],
        trainingSessions: [],
        modulePages: [],
        villageGroups: [],
        fieldBooks: [],
        soilReports: [],
        trainingReport: [],
        subLoading: false,
        soilReportSummary: [],
        fieldBookSummary: [],
        sessionAttendance: [],
        adOptionData: [],
        adOptionPagination: null,
        adOptionSummaryReport: [],
        villageGroupAdoptionSummaryReport: [],
        individualFarmersDetails: [],
        user_client_id: savedClientId,
        trainingPlanLevelReports: [],
    });
 
    const [employees, setEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const hasLoadedRef = useRef(false);

    const navigate = useNavigate();

    // ✅ Common API handler
    const fetchData = useCallback(async (fetchFunction, params = {}) => {
        try {
            return await fetchFunction(setData, setError, params);
        } catch (err) {
            setError(err?.response?.data?.message || err.message);
            console.error(err);
        }
    }, []);

    // ✅ After login load
    const fetchDataAfterLogin = useCallback(async () => {
        setLoading(true);

        try {
            await Promise.all([
                fetchData(fetchYears),
                fetchData(fetchTrinigTypes),
                fetchData(fetchLevels, {
                    level_id: data?.user.level_id,
                    client_id: data?.user_client_id
                }),
                fetchData(fetchUserLevels),
                fetchData(fetchTrainingStatus),
                fetchData(fetchSoilTypes),
                fetchData(fetchModulePages),
                fetchData(fetchCropTypes),
            ]);

            const emp = await fetchData(fetchEmployees, {
                client_user_id: data.user.user_id,
                client_id: data.user_client_id
            });

            setEmployees(emp || []);

        } catch (err) {
            setError(err?.message);
        } finally {
            setLoading(false);
        }
    }, [fetchData, data.user.user_id, data.user_client_id]);

    // ✅ Token check
    useEffect(() => {
        const token = Cookies.get('farmerToken');

        if (!token) {
            navigate("/");
            setLoading(false);
            return;
        }

        const decoded = jwtDecode(token);
        const user = decoded?.token?.[0];

        if (!user) {
            navigate("/");
            setLoading(false);
            return;
        }

        const storedClientId = localStorage.getItem("user_client_id");
        const clientId = storedClientId ? Number(storedClientId) : Number(user.client_id);

        setData(prev => ({ ...prev, user, user_client_id: clientId }));

        if (!storedClientId) {
            localStorage.setItem("user_client_id", clientId);
        }

        setIsAuthenticated(true);

    }, [navigate]);

    // ✅ Load initial data
    useEffect(() => {
        if (isAuthenticated) {
            fetchDataAfterLogin();
        }
    }, [isAuthenticated, fetchDataAfterLogin]);

    // ✅ Load client dependent data
    const loadClientBaseChange = async (clientId) => {
        setData(prev => ({ ...prev, subLoading: true }));

        try {
            await Promise.all([
                fetchData(fetchTrainingPlans, { client_id: clientId }),
                fetchData(fetchTrainingSessions, { client_id: clientId, employees }),
                fetchData(fetchTrainingPlanLevelWiseReport, {
                    level_id: data.user.level_id !== null
                        ? data.user.level_id
                        : Number(localStorage.getItem("user_client_id")) === 1
                            ? 1
                            : 2,
                    client_id: Number(localStorage.getItem("user_client_id")) || 1,
                    employees
                }),
            ]);
        } finally {
            setData(prev => ({ ...prev, subLoading: false }));
        }
    };

    // ✅ Safe initial trigger
    useEffect(() => {
        if (isAuthenticated && savedClientId && !hasLoadedRef.current) {
            hasLoadedRef.current = true;
            loadClientBaseChange(savedClientId);
        }
    }, [isAuthenticated, savedClientId]);

    // ✅ Client switch handler (FIXED)
    const handleClientIdChange = async (id) => {
        if (!id) return;

        setData(prev => ({
            ...prev,
            user_client_id: id,
            subLoading: true
        }));

        localStorage.setItem("user_client_id", id);

        try {
            const emp = await fetchData(fetchEmployees, {
                client_user_id: data.user.user_id,
                client_id: id
            });

            setEmployees(emp || []);

            await loadClientBaseChange(id);

        } finally {
            setData(prev => ({
                ...prev,
                subLoading: false
            }));
        }
    };

    // ✅ Employees dependent data
    useEffect(() => {
        if (employees.length === 0) return;

        const load = async () => {
            setData(prev => ({ ...prev, subLoading: true }));

            try {
                await Promise.all([
                    fetchData(fetchFarmers, { employees }),
                    fetchData(fetchTrainingSessions, { employees, client_id: data.user_client_id }),
                    fetchData(fetchSoilReports, { employees }),
                    fetchData(fetchFieldBook, { employees }),
                    fetchData(fetchVillageGroups, { employees }),
                    fetchData(fetchAdOption, { employees }),
                    fetchData(fetchSoilReportSummary, { employees, year_id: 2 }),
                    fetchData(fetchTrainingPlanLevelWiseReport, {
                        client_id: Number(localStorage.getItem("user_client_id")) || 1,
                        level_id: data.user.level_id !== null
                            ? data.user.level_id
                            : Number(localStorage.getItem("user_client_id")) === 1
                                ? 1
                                : 2,
                        employees,
                    }),
                ]);
            } finally {
                setData(prev => ({ ...prev, subLoading: false }));
            }
        };

        load();
    }, [employees, data.user_client_id, fetchData]);

    // ✅ Logout

    const handleLogout = () => {
        Cookies.remove('farmerToken');
        localStorage.removeItem('user_client_id');
        localStorage.removeItem('client_id');
        navigate(APP_ROUTES.LOGIN);
        setData(prev => ({ ...prev, user_client_id: "" }));
    };


    const handleTrainingPlans = useCallback(() => fetchData(fetchTrainingPlans, { level_id: data.user.level_id, client_id: data.user_client_id }), [data.user.level_id, data.user_client_id, fetchData]);

    // Callback for fetching training sessions
    const handleTrainingSessions = useCallback(() => fetchData(fetchTrainingSessions, { employees, client_id: data.user_client_id }), [employees, data.user_client_id, fetchData]);

    const handleTrainingPlanReport = useCallback(async (level_id) => {
        if (level_id) {
            await fetchData(fetchTrainingPlanLevelWiseReport, {
                level_id,
                client_id: Number(localStorage.getItem("user_client_id")) || 1,
                employees
            });
        }
    }, [data.user_client_id, employees]);

    // Callback for fetching employees
    const handleEmployees = useCallback(() => fetchData(fetchEmployees, { client_user_id: data.user.user_id, client_id: Number(localStorage.getItem("user_client_id")) || 1 }), [data.user.user_id, fetchData]);

    const handleFieldBooks = useCallback(() => fetchData(fetchFieldBook, { employees }), [employees, fetchData]);

    // Callback for fetching soil reports
    const handleSoilReports = useCallback(() => fetchData(fetchSoilReports, { employees }), [employees, fetchData]);

    // ---- AdOption server-side pagination (page/limit shared via context) ----
    const [adOptionPage, setAdOptionPage] = useState(1);
    const [adOptionLimit, setAdOptionLimit] = useState(10);
    const [adOptionLoading, setAdOptionLoading] = useState(false);

    // wraps the fetch with a loading flag for the shimmer loader
    const fetchAdOptionPage = useCallback(async (page, limit) => {
        setAdOptionLoading(true);
        try {
            await fetchData(fetchAdOption, { employees, page, limit });
        } finally {
            setAdOptionLoading(false);
        }
    }, [employees, fetchData]);

    const handleAdOption = useCallback(
        (page = adOptionPage, limit = adOptionLimit) => fetchAdOptionPage(page, limit),
        [fetchAdOptionPage, adOptionPage, adOptionLimit]
    );

    // called by the table's page buttons (1-based page)
    const handleAdOptionPageChange = useCallback((page) => {
        setAdOptionPage(page);
        fetchAdOptionPage(page, adOptionLimit);
    }, [fetchAdOptionPage, adOptionLimit]);

    // called by the rows-per-page selector
    const handleAdOptionLimitChange = useCallback((limit) => {
        setAdOptionLimit(limit);
        setAdOptionPage(1);
        fetchAdOptionPage(1, limit);
    }, [fetchAdOptionPage]);

    const handleTrainingReport = useCallback((trainingId) => {
        if (trainingId) {
            fetchData(fetchTrainingReport, { employees, training_plan_id: trainingId });
        }
    }, [employees, fetchData]);


    const handleSoilReportSummary = useCallback((year_id) => {

        if (year_id) {
            fetchData(fetchSoilReportSummary, { employees, year_id: year_id });
        }
    }, [employees, fetchData]);

    const handleFieldBookSummary = useCallback((year_id) => {

        if (year_id) {
            fetchData(fetchFieldBookSummary, { employees, year_id: year_id });
        }
    }, [employees, fetchData]);

    const handleAdOptionSummary = useCallback((year_id) => {
        if (year_id) {
            fetchData(fetchAdOptionSummary, { employees, year_id: year_id });
        }
    }, [employees, fetchData])

    const handleAttendance = useCallback((training_session_id) => {
        if (training_session_id) {
            fetchData(fetchAttendance, { training_session_id: training_session_id });
        }
    }, [employees, fetchData]);

    const handleIndividualFarmersDetails = useCallback((training_session_id) => {

        if (training_session_id) {
            fetchData(fetchIndividualFarmersDetails, { training_session_id: training_session_id });
        }
    }, [employees, fetchData]);


    const handleVillageGroupAdoptionSummary = useCallback((year_id) => {
        if (year_id) {
            fetchData(fetchVillageGroupsAdOptionSummary, { employees, year_id: year_id });
        }
    }, [employees, fetchData])

    const contextValue = useMemo(() => ({
        ...data,
        employees,
        loading,
        error,
        fetchDataAfterLogin,
        handleTrainingPlans,
        handleEmployees,
        handleTrainingPlanReport,
        handleFieldBooks,
        handleTrainingSessions,
        handleSoilReports,
        handleTrainingReport,
        handleSoilReportSummary,
        handleFieldBookSummary,
        handleAttendance,
        handleAdOption,
        adOptionPage,
        adOptionLimit,
        adOptionLoading,
        handleAdOptionPageChange,
        handleAdOptionLimitChange,
        handleAdOptionSummary,
        handleVillageGroupAdoptionSummary,
        handleIndividualFarmersDetails,
        handleClientIdChange,
        handleLogout,
    }), [data, employees, loading, error, fetchDataAfterLogin, handleTrainingPlans, handleTrainingPlanReport, handleEmployees, handleFieldBooks, handleTrainingSessions, handleSoilReports, handleTrainingReport, handleSoilReportSummary, handleFieldBookSummary, handleAttendance, handleAdOption, adOptionPage, adOptionLimit, adOptionLoading, handleAdOptionPageChange, handleAdOptionLimitChange, handleAdOptionSummary, handleVillageGroupAdoptionSummary, handleIndividualFarmersDetails]);

    return (
        <DataContext.Provider value={contextValue}>
            {loading ? <LoadingComponent /> : children}
        </DataContext.Provider>
    );
};

export const useData = () => useContext(DataContext);